import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { SharedService } from 'src/app/services/sharedService';

@Component({
  selector: 'rdf-custom-value-emitter',
  templateUrl: './custom-value-emitter.component.html',
  styleUrls: ['./custom-value-emitter.component.css']
})
export class CustomValueEmitterComponent implements OnInit {
  @Input()
  selectables
  selectItems = []
  @Input() row
  @Input() col
  @Output() onSelectedValue = new EventEmitter<any>()
  emittables = []
  blocks = []
  stageName: any
  stageKey: any
  blockKey: any
  rowEmitter: any
  columnEmitter: any
  columns: any
  field: any
  rowCustomValueEmitter
  constructor() { }

  ngOnInit() {

    if (Array.isArray(this.row.customValueEmitter)) {
      const cValEmitter = this.row.customValueEmitter.find(elem => elem.localColumn === this.col.key)
      if (cValEmitter)
        this.rowCustomValueEmitter = JSON.parse(JSON.stringify(cValEmitter))
    } else {
      if (this.row.customValueEmitter)
        this.rowCustomValueEmitter = JSON.parse(JSON.stringify(this.row.customValueEmitter))
    }
    if (this.rowCustomValueEmitter) {
      this.stageKey = this.rowCustomValueEmitter.stageKey
      this.stageName = this.rowCustomValueEmitter.stage
      if (!this.rowCustomValueEmitter.blockKey) {
        this.detectBlock(this.rowCustomValueEmitter)
      } else {
        this.blockKey = this.rowCustomValueEmitter.blockKey
      }
      let st
      if (this.stageKey) {
        st = this.selectables.find(elem => elem.key === this.stageKey)
        this.blocks = Object.keys(st.emittables)
        if (this.blockKey) {
          this.emittables = st.emittables[this.blockKey].map(el => { return { name: el.name, key: el.key } })
        }
        if (this.rowCustomValueEmitter.column) {
          this.field = st.emittables[this.blockKey].find(elem => elem.key === this.rowCustomValueEmitter.key)
          if (this.field.values) {
            for (let c of this.field.values) {
              this.columns = this.field.values.map(el => el.column)
            }
          }
        }
      }
      this.rowEmitter = this.rowCustomValueEmitter.key
      this.columnEmitter = this.rowCustomValueEmitter.column
    }
  }
  changeRowSelection(ev) {
    let st = this.selectables.find(elem => elem.key === this.stageKey)
    this.field = st.emittables[this.blockKey].find(elem => elem.key === ev.value)
    if (this.field.values) {
      for (let c of this.field.values) {
        this.columns = this.field.values.map(el => el.column)
      }
    } else {
      this.columns = undefined
      this.onSelectedValue.emit({ key: this.field.key, stage: this.stageName, stageKey: this.stageKey, blockKey: this.blockKey, name: this.field.name })
    }
  }
  changeColumnSelection(ev) {
    this.onSelectedValue.emit({ key: this.field.key, stage: this.stageName, stageKey: this.stageKey, blockKey: this.blockKey, name: this.field.name, column: ev.value })
  }
  changeStageSelection(ev) {
    let st = this.selectables.find(elem => elem.key === ev.value)
    this.stageName = st.name
    this.stageKey = st.key
    this.blocks = Object.keys(st.emittables)
  }
  changeBlockSelection(ev) {
    let st = this.selectables.find(elem => elem.key === this.stageKey)
    this.blockKey = ev.value
    this.emittables = st.emittables[this.blockKey].map(el => { return { name: el.name, key: el.key } })
  }
  public objectComparisonFunction = function (option, value): boolean {
    if (value)
      return option.key === value.key;
    return false;
  }
  detectBlock(rowValueEmitter) {
    if (Array.isArray(rowValueEmitter)) {
    }
    else {
      let st = this.selectables.find(elem => elem.key === this.stageKey)
      for (let em in st.emittables) {
        if (st.emittables[em].find(elem => elem.key === rowValueEmitter.key)) {
          this.blockKey = em
        }
      }
    }
  }

}